export default __webpack_public_path__ + "static/media/noData.d830f3df.svg";